import React from 'react';

import {TComponentRef, formField, newFormField} from '../FormField';
import * as S from './style';

export type TProps = TComponentRef &
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    isInvalid?: boolean;
    resize?: boolean;
  };

const Textarea = React.memo<TProps>(
  ({
    id: propId,
    resize = false,
    onChange,
    onFocus,
    onBlur,
    disabled,
    readOnly,
    innerRef,
    ...props
  }) => {
    const id = propId || props.name;

    return (
      <S.Textarea
        id={id}
        onChange={disabled || readOnly ? undefined : onChange}
        onFocus={disabled ? undefined : onFocus}
        onBlur={disabled ? undefined : onBlur}
        resize={resize}
        readOnly={readOnly}
        disabled={disabled}
        ref={innerRef}
        {...props}
      />
    );
  },
);

export default Textarea;

export const TextareaField = formField<TProps, string>(Textarea);

export const NewTextareaField = newFormField<TProps>(Textarea);
